import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import * as Actions from "../actions/UploadOrganizationIcon";

import { addNotification, loading } from "layouts/AppLayout/modules";

export function* uploadOrgIcon(action: Actions.UploadOrgIconAction) {
    const { blob, contentType, credentials, orgId } = action.payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.uploadOrgIcon(orgId, blob, contentType);
        yield put(Actions.uploadOrgIconSuccess(result.organization.logoUrl));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.uploadOrgIconFailure(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUploadOrgIcon() {
    yield takeEvery(Actions.UPLOAD_ORG_ICON, uploadOrgIcon);
}
